// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SuggestionCard-cls1___e7004fdcb03e3fa38ae{/*!*/}.SuggestionCard-cls2__dabcbe2c544989eed587{--size: 48px;flex-shrink:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SuggestionCard-cls1___e7004fdcb03e3fa38ae",
	"cls2": "SuggestionCard-cls2__dabcbe2c544989eed587 SuggestionCard-cls1___e7004fdcb03e3fa38ae"
};
export default ___CSS_LOADER_EXPORT___;
